export const searchParams = {
  MEDIA_TYPE: 'mediaType',
} as const;
